import useTimer from "../hooks/UseTimer";

function Timer() {
  const { time, formatTime } = useTimer();

  return <div>{formatTime(time)}</div>;
};

export default Timer
